import React, { memo } from "react";
import { Button, Box, Chip, Typography, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
const useStyles = makeStyles((theme) => ({
  filterbtn: {
    margin: "5px",
    padding: "10px",
  },
  filterTitle: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "1rem",
    lineHeight: "1.6",
    letterSpacing: "0.0075em",
    fontWeight: "400",
    color: "#fff",
    paddingLeft: "3px ",
  },
  auditFilterContainer: {
    display: "flex",
    flexFlow: "column",
    columnGap: "10px",
    padding: "1rem",
    background: "#fff",
    width: "350px",
  },
  headerBox: {
    background: "#1e3f7e",
    borderRadius: "5px",
    padding: "3px",
    margin: "8px 0px 8px 0px",
  },
  filterBtn: {
    fontSize: "11px !important",
  },
}));

const AuditFilterTabList = ({
  strengthAndAgility,
  shooting,
  ballHandling,
  situationalWorkOuts,
  handaleFilterSelection,
  filterSelection,
  clearAuditFilter,
  handleDeleteFilterSelection,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.auditFilterContainer}>
        <Box sx={{ paddingLeft: "1rem" }}>
          <Button
            size="small"
            variant={
              filterSelection.arrayvar.includes("All")
                ? "contained"
                : "outlined"
            }
            onClick={() => handaleFilterSelection("All")}
            startIcon={<PlayCircleIcon />}
            className={classes.filterBtn}
          >
            All
          </Button>
        </Box>
        <Box sx={{ paddingLeft: "1rem" }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Typography
              component="legend"
              variant="body2"
              className={classes.filterTitle}
            >
              Strength And Agility
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {strengthAndAgility.map((option, index) => {
              return (
                <>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      size="small"
                      variant={
                        filterSelection.arrayvar.includes(option)
                          ? "contained"
                          : "outlined"
                      }
                      onClick={() => handaleFilterSelection(option)}
                      className={classes.filterBtn}
                    >
                      {option}
                    </Button>
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Box>
        <Box sx={{ paddingLeft: "1rem" }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Typography
              component="legend"
              variant="body2"
              className={classes.filterTitle}
            >
              Shooting Drills
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {shooting.map((option, index) => {
              return (
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    size="small"
                    variant={
                      filterSelection.arrayvar.includes(option)
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => handaleFilterSelection(option)}
                    className={classes.filterBtn}
                  >
                    {option}
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box sx={{ paddingLeft: "1rem" }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Typography
              component="legend"
              variant="body2"
              className={classes.filterTitle}
            >
              Ball Handling
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {ballHandling.map((option, index) => {
              return (
                <Grid item xs={6}>
                  <Button
                    size="small"
                    fullWidth
                    variant={
                      filterSelection.arrayvar.includes(option)
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => handaleFilterSelection(option)}
                    className={classes.filterBtn}
                  >
                    {option}
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box sx={{ paddingLeft: "1rem" }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Typography
              component="legend"
              variant="body2"
              className={classes.filterTitle}
            >
              Situational WorkOuts
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {situationalWorkOuts.map((option, index) => {
              return (
                <Grid item xs={6}>
                  <Button
                    size="small"
                    fullWidth
                    variant={
                      filterSelection.arrayvar.includes(option)
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => handaleFilterSelection(option)}
                    className={classes.filterBtn}
                  >
                    {option}
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default memo(AuditFilterTabList);
